// extracted by mini-css-extract-plugin
export var animating = "_2y-3";
export var background = "_2y-6";
export var constrainHeight = "_2y-2";
export var dark = "_2y-4";
export var dropdown = "_2y-1";
export var leave = "_2y-5";
export var option = "_2y-7";
export var root = "_2y-0";